import styled from "@emotion/styled";

interface HeadingProps {
    weight?: number;
    mt?: number;
}

export const H1 = styled.h1<HeadingProps>`
    color: ${({ theme }) => theme.color[1]};
    font-size: 24px;
    font-style: normal;
    font-weight: ${({ weight }) => (weight ? weight : 700)};
    line-height: 1.5;
    margin: ${({mt}) => (mt ? `${mt}px` : 0)} 0 0;
`;

export const H2 = styled.h2<HeadingProps>`
    color: ${({ theme }) => theme.color[1]};
    font-size: 20px;
    font-style: normal;
    font-weight: ${({ weight }) => (weight ? weight : 700)};
    line-height: 1.5;
    margin: ${({mt}) => (mt ? `${mt}px` : 0)} 0 0;
`;

export const H3 = styled.h3<HeadingProps>`
    color: ${({ theme }) => theme.color[2]};
    font-size: 18px;
    font-style: normal;
    font-weight: ${({ weight }) => (weight ? weight : 700)};
    line-height: 1.5;
    margin: ${({mt}) => (mt ? `${mt}px` : 0)} 0 0;
`;

export const H4 = styled.h4<HeadingProps>`
    color: ${({theme}) => theme.color[2]};
    font-size: 14px;
    font-style: normal;
    font-weight: ${({weight}) => (weight ? weight : 500)};
    line-height: 1.5;
    white-space: pre-wrap;
    margin: ${({mt}) => (mt ? `${mt}px` : 0)} 0 0;
`;

export const H5 = styled.h5<HeadingProps>`
    color: ${({ theme }) => theme.color[4]};
    font-size: 12px;
    font-style: normal;
    font-weight: ${({ weight }) => (weight ? weight : 700)};
    line-height: normal;
    margin-top: ${({ mt }) => (mt ? `${mt}px` : 0)};
`;

export const P = styled.p`
    display: block;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.color[3]};
    white-space: pre-wrap;
    margin: 5px 0;
    line-height: 1.5;

    &:last-child {
        margin-bottom: 0;
    }
`;
export const P2 = styled.p`
    display: block;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    color: ${({ theme }) => theme.color[4]};
    white-space: pre-wrap;
    margin: 5px 0;
    line-height: 1.5;

    &:last-child {
        margin-bottom: 0;
    }
`;
export const P3 = styled.p`
    display: block;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    color: ${({ theme }) => theme.color[3]};
    white-space: pre-wrap;
    margin: 5px 0;
    line-height: 1.5;
    &:last-child {
        margin-bottom: 0;
    }
`;
export const Des = styled.div`
    display: block;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    color: ${({ theme }) => theme.color[3]};
    white-space: pre-wrap;
    margin: 5px 0;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const Span = styled.span`
    color: ${({ theme }) => theme.color[3]};
    font-weight: 400;
    font-size: 14px;
`;

export const Bullet = styled.ul`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 13px;
    color: #727272;
    white-space: pre-wrap;
    margin: 2px 0;
    padding-left: 15px;
    position: relative;

    &:before {
        content: " ";
        position: absolute;
        left: 0;
        width: 5px;
        height: 5px;
        background-color: #727272;
        border-radius: 50%;
    }
`;
